import Swiper, { Manipulation, Navigation, Pagination, Lazy, Zoom, Thumbs } from 'swiper';
Swiper.use([Manipulation, Navigation, Pagination, Lazy, Zoom, Thumbs]);

export default function setGallery(Product) {
  const _this = this;

  const thumbs = new Swiper(Product.thumbsSlider.element, {
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 1000,
    watchSlidesProgress: true,
    watchOverflow: true,
    preloadImages: false,
    lazy: {
      checkInView: true,
      loadOnTransitionStart: true,
      loadPrevNext: false
    },
    navigation: {
      nextEl: '[data-slider-thumbs] .swiper-button-next',
      prevEl: '[data-slider-thumbs] .swiper-button-prev',
    },
    pagination: {
      el: '.swiper-thumb-pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  const main = new Swiper(Product.mainSlider.element, {
    slidesPerView: 1,
    speed: 1000,
    watchOverflow: true,
    watchSlidesProgress: true,
    thumbs: {
      swiper: thumbs,
    },
    preloadImages: false,
    lazy: {
      checkInView: true,
      loadOnTransitionStart: true
    },
    zoom: {
      maxRatio: 2,
      zoomedSlideClass: '-zoomed'
    },
    navigation: {
      nextEl: '[data-main-slider] .swiper-button-next',
      prevEl: '[data-main-slider] .swiper-button-prev',
    },
    pagination: {
      el: '[data-main-slider] .swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
  });

  Product.thumbsSlider.swiper = thumbs;
  Product.mainSlider.swiper = main;
}